import { Box, Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { capitalize } from 'lodash';
import { FlexCol } from '@/UI/styles';
import { I18N_KEYS } from '@/language/keys';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { FF_FIGMA_OAUTH_CONNECT } from '@/consts/featureFlags';
import { User } from '@/types/auth.types';
import ProfileProperty from './ProfileProperty';
import { LinkedAccounts } from './LinkedAccounts';

interface ProfileProps {
  user: User;
}

function Profile({ user }: ProfileProps) {
  const { t } = useTranslation();
  const { value: isFigmaOauthConnectEnabled } = useFeatureFlag(FF_FIGMA_OAUTH_CONNECT);

  return (
    <FlexCol sx={{ flex: 1, gap: 4 }}>
      <Avatar alt="user image" src={user.photoURL || ''} sx={{ width: 86, height: 86, mr: 1 }} />
      <Box data-testid="profile-name-container">
        <ProfileProperty label={t(I18N_KEYS.GENERAL.NAME)} value={user.displayName || ''} />
      </Box>
      <Box data-testid="profile-email-container">
        <ProfileProperty label={t(I18N_KEYS.GENERAL.EMAIL)} value={user.email || ''} />
      </Box>
      <Box data-testid="profile-role-container">
        <ProfileProperty label={t(I18N_KEYS.GENERAL.ROLE)} value={capitalize(user.activeWorkspace?.role || '')} />
      </Box>
      {isFigmaOauthConnectEnabled && <LinkedAccounts />}
    </FlexCol>
  );
}

export default Profile;
